import type { QuickloadUrl } from './quickload.types';
import { QuickloadDefinitions } from './quickload-definitions.generated';
// Don't import from index so that we can keep bundle size as low as possible
// eslint-disable-next-line no-restricted-imports
import { getInvitationTokens } from '@trello/session-cookie/src/getInvitationTokens';
// Don't import from index so that we can keep bundle size as low as possible
// eslint-disable-next-line no-restricted-imports
import { getRecordedFeatureFlag } from '@trello/feature-flag-client/src/getRecordedFeatureFlag';

export const getPreloadsFromPath = (
  pathname: string = window.location.pathname,
  search: string = window.location.search,
  cookie: string = window.document.cookie,
): {
  path: string;
  preloads: QuickloadUrl[];
  param: string;
} => {
  const formattedPath = pathname.replace(/\?(.*)$/, '');

  // Find the preloads that match the current pathname
  // by using regular expressions
  const preloadKeyMatch = Object.keys(QuickloadDefinitions).find(
    (routeRegExp) => {
      const routeDefinition = QuickloadDefinitions[routeRegExp];
      const routeRegex = new RegExp(routeRegExp);
      // Check that the requests associated with the route are either not FFed or evaluate to true.
      if (
        routeDefinition.find(
          (req) =>
            !req.featureFlag ||
            getRecordedFeatureFlag(req.featureFlag, 'false') === 'true',
        )
      ) {
        return routeRegex.test(formattedPath);
      }
      return false;
    },
  );
  const preloads =
    preloadKeyMatch &&
    QuickloadDefinitions[preloadKeyMatch].filter(
      (req) =>
        !req.featureFlag ||
        getRecordedFeatureFlag(req.featureFlag, 'false') === 'true',
    );

  // exec the param using the reg exp to get the org name, board id, card id, etc.
  let param = new RegExp(preloadKeyMatch || '').exec(formattedPath)?.[1] || '';

  // exception for search is to exec against q search param
  if (new RegExp(`^/search$`).test(pathname)) {
    param = new URLSearchParams(search).get('q') || '';
  }

  // get header definitions and append them as well
  const headerDefinitions = QuickloadDefinitions.header;
  const invitationTokens = getInvitationTokens();

  const formattedPreloads = headerDefinitions
    .concat(preloads || [])
    .map(({ url, rootId, operationName, modelName }) => {
      url = url.replace(rootId, rootId === ':idMember' ? 'me' : param);
      url += invitationTokens ? `&invitationTokens=${invitationTokens}` : '';

      if (new RegExp('^/1/search').test(url)) {
        const dscToken = /dsc=([^;]+)/.exec(cookie)?.[1];
        // We probably shouldn't be setting this to the string "undefined", but this
        // was to preserve the functionality of the code after conversion to TypeScript.
        url += `&dsc=${dscToken ?? 'undefined'}`;
      }

      return {
        url,
        operationName,
        modelName,
        queryName: operationName.replace('quickload:', ''),
      };
    });

  return {
    path: formattedPath,
    preloads: formattedPreloads,
    param,
  };
};
